<div class="policy-container" dir="rtl">
    <h3>سياسة <span>الاسترداد</span></h3>
    <div>
        <h2>شروط الاسترداد</h2>
        <ul>
            <li>يحق للعميل استرداد المبلغ إذا لم يشاهد أكثر من <strong>3 فيديوهات</strong> من الدورة المشتراة.</li>
            <li>يجب تقديم طلب الاسترداد خلال <strong>30 يومًا</strong> من تاريخ الشراء.</li>
            <li>إذا تمت مشاهدة أكثر من 3 فيديوهات، تُعدّ الدورة مستخدمة ولا يمكن استرداد المبلغ.</li>
            <li>الاسترداد متاح فقط للدورات المشتراة مباشرةً عبر <strong>البرشمة</strong>. المشتريات عبر منصات أخرى تخضع
                لسياساتها الخاصة.</li>
        </ul>

        <h2>كيفية طلب الاسترداد</h2>
        <ol>
            <li>تواصل مع فريق الدعم على <strong>support@el-bershama.com</strong> مع تفاصيل طلبك.</li>
            <li>سيتحقق فريقنا من استيفاء شروط الاسترداد.</li>
            <li>في حال الموافقة، سيُعاد المبلغ خلال <strong>7 أيام</strong> إلى وسيلة الدفع الأصلية.</li>
        </ol>

        <h2>الاستثناءات</h2>
        <ul>
            <li>لا يُقبل الاسترداد للدورات التي اكتملت مشاهدتها بالكامل.</li>
            <li>لا يُقبل الاسترداد على العروض والخصومات إلا إذا نُص على خلاف ذلك.</li>
            <li>أي طلب لا يستوفي الشروط المذكورة لن يتم قبوله.</li>
        </ul>

        <p>نقدّر تفهمكم ودعمكم. إن كان لديك أي استفسار، لا تتردد في التواصل مع فريق خدمة العملاء.</p>

        <h2>تواصل معنا</h2>
        <p><strong>البريد الإلكتروني:</strong> support@el-bershama.com</p>
        <p><strong>الهاتف:</strong> 201013703712+</p>

        <p><strong>فريق البرشمة</strong></p>
    </div>
</div>